import { Box, Grid, Theme, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// import { getNationalityList } from '../../redux-store/actions';
import { FatcaMdmsData } from '../../redux-store/actions/application';
import {
  Applicant,
  DataMasters,
  dataTypeMasters,
  FatcaMdms,
  nonIndividualMdmsQuestionsFatca,
} from '../../redux-store/types/api-types';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import {
  AssignAnsAndVisibilityForInitialFatca,
  BorderedTextField,
  Group,
  OpenTextField,
  SectionHeader,
  SingleChoiceRadio,
} from '../NonIndividualInvestor/fatca';
import { getDataMasters } from '../../redux-store/actions/onBoarding';

interface Values {
  applicants: {
    fatcadetail: nonIndividualMdmsQuestionsFatca;
  }[];
}

export default function Fatca({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  const [fatcaData, setFatcaData] = useState<Values>();
  const dispatch = useDispatch();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<dataTypeMasters[]>([]);

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(FatcaMdmsData())) as unknown as FatcaMdms;
        // const nationalitiesMdmsMasters = (await dispatch(
        //   getNationalityList()
        // )) as unknown as nationaliyType;
        // setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const { data: dataMasters } = (await dispatch(getDataMasters())) as unknown as DataMasters;
        setMdmsCountriesList(dataMasters?.COUNTRY || []);
        if (response.fatca_questions) {
          const _applicants = {
            applicants: applicants.map((applicant) => {
              const { fatcadetail: existingFatcaDetails = null } = applicant || {};
              return {
                fatcadetail: existingFatcaDetails
                  ? AssignAnsAndVisibilityForInitialFatca(
                    response.fatca_questions,
                    existingFatcaDetails
                  )
                  : [],
              };
            }),
          };
          setFatcaData(_applicants as Values);
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  return (
    <Box
      sx={(theme: Theme) => ({
        bgcolor: 'white',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: '10px',
        border: `1px solid ${theme.palette.grey[100]}`,
        padding: '25px',
      })}
      mt={5}>
      <Box >
        <Grid container >
          <Grid item xs={12}>
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
              Fatca Details
            </Typography>
          </Grid>
          <Formik
            initialValues={fatcaData as Values}
            enableReinitialize={true}
            onSubmit={() => {
              console.log('this action should not be trigered');
            }}>
            {({ values }) => (
              <Grid container>
                {values?.applicants.map((applicant, idx) => (
                  <React.Fragment key={idx}>
                    {applicant.fatcadetail.length === 0 && (
                      <Grid
                        xs={12}
                        sm={12}
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: 'common.black',
                          textAlign: 'center',
                          my: 3,
                        }}>
                        No Fatca Details
                      </Grid>
                    )}
                    {applicant.fatcadetail.map((item) => (
                      <React.Fragment key={item.id}>
                        {item.isVisible &&
                          item.section_header &&
                          item.question_type !== 'group' && (
                            <SectionHeader value={item.section_header} />
                          )}
                        {item.isVisible && item.question_type === 'single_choice_radio' && (
                          <SingleChoiceRadio
                            data={item}
                            values={applicant.fatcadetail}
                            formValuesIndex={idx}
                            questionId={item.id}
                            disabled={true}
                          />
                        )}
                        {item.isVisible && item.question_type === 'group' && (
                          <Group
                            data={item}
                            formValuesIndex={idx}
                            values={applicant.fatcadetail}
                            _applicants={applicants}
                            disabled={true}
                            nationalityDropdown={mdmsCountriesList}
                          />
                        )}
                        {item.isVisible && item.question_type === 'open_text_field' && (
                          <OpenTextField
                            text={item.question_text}
                            applicantsIndex={idx}
                            questionId={item.id}
                            placeHolder={item?.placeholder || 'Please enter text here'}
                            isMandatory={item.isMandatory}
                            disabled={true}
                          />
                        )}
                        {item.isVisible && item.question_type === 'bordered_text_field' && (
                          <Grid item xs={12} sm={6} sx={{ pr: { xs: 0, sm: '30px' }, pt: 2 }}>
                            <BorderedTextField
                              applicantsIndex={idx}
                              questionId={item.id}
                              label={item.question_text}
                              placeHolder={item?.placeholder || 'Please enter text here'}
                              isMandatory={item.isMandatory}
                              disabled={true}
                            />
                          </Grid>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </Grid>
            )}
          </Formik>
        </Grid>
      </Box>
    </Box>
  );
}
